// extracted by mini-css-extract-plugin
export default {"battleSelectorWrap":"ClanRatings-module_battleSelectorWrap_cc386","seasonMenu":"ClanRatings-module_seasonMenu_a0189"};